import { Component, Input, OnInit } from '@angular/core';
import { SouvenirsModel } from '../SouvenirsModel';
import { SouvenirsImagesModel } from '../SouvenirsImagesModel';
import { SouvenirsService } from '../souvenirs.service';
import { ActivatedRoute, Router } from '@angular/router';
import { FormBuilder } from '@angular/forms';
import { CountriesService } from '../../MasterData/countries.service';
import { CountriesModel } from '../../MasterData/CountriesModel';
@Component({
    // moduleId: module.id,
    selector: 'all-souvenirs',
    templateUrl: 'all-souvenirs.component.html',
    styleUrls: ['all-souvenirs.component.scss']
})
export class AllSouvenirsComponent implements OnInit {
    Menuoption = 'center';
    Settingicon = true
      projectDetails : any;
      projectGallaryConfig  = {"slidesToShow": 1,"fade": true, "slidesToScroll": 1,"arrows": false,"dots": false,"autoplay": true, "autoplaySpeed": 2000};
    declare lang: any;
  
      constructor(  
          public router: Router,
          private formBuilder : FormBuilder,
          private modelService :SouvenirsService,
          private CountriesService:CountriesService,
          private route: ActivatedRoute,
          ) {      this.id = +route.snapshot.paramMap.get("id");
         }
         id=0;
         ngOnInit() {
          this.lang = localStorage.getItem('theme_lang');
          debugger;
          this.modelService.getAll().subscribe(data=>{
              this.rows=data;
              console.log("modelObject",this.rows)
          })
          this.CountriesService.getAll().subscribe(data=>{
            this.CountriesList=data;
          })
          if(this.id > 0)
          {
            debugger;
            this.modelService.getById(this.id).subscribe(data=>{
              this.modelObject=data;
              this.files=this.modelObject.souvenirImagesList;
              console.log("modelObject",this.rows)
            })
          }
          else{
          }
      }
      selectedIndex: number = 0;
      @Input()
      data:any;
      modelObject: SouvenirsModel = new SouvenirsModel();
      rows :SouvenirsModel[]= [];
      CountriesList:CountriesModel[]=[];
      files:SouvenirsImagesModel[]=[];
      public picurl: string ='';
      editEnabled = true;
        goBack(){
          this.router.navigate(['/blimp/events']);
        }
        SouvenirsDetails(id){
          this.router.navigate(['/camps-details/',id]);
          
        }
        getByCountry(){
            debugger;
            
                 this.modelService.getAllByCountryId(this.modelObject.countryId).subscribe(data=>{
                   this.rows=data;
                 })
                  }
    
  }
  
